import { SortColumn } from '@bst/react-data-grid';
import { useInfiniteQuery } from '@tanstack/react-query';
import { BaseFilterDTO } from '../../../apiclients/bstinsights';
import { default as useAcquireToken } from '../../AuthToken/Hooks/useAcquireToken';
import { default as useBSTInsightsAPI } from '../../../apiclients/api/bstinsightsapi';
import { useStores } from '../../../stores/useStores';

import { useGridPreferences } from './useGridPreferences';
import { GRID_DATA_QUERY_PREFIX, PAGE_SIZE } from './utils/constants';

type UseGetUsersProps = {
  sort?: SortColumn;
  enabled?: boolean
  filters?: BaseFilterDTO[];
}

// Returns query key of users query. Used when query cache is optimistically updated
export const useGetUsersPagedQueryKey = () => {
  const { sort } = useGridPreferences();
  const { userManagementStore } = useStores()
  return [
    GRID_DATA_QUERY_PREFIX,
    sort?.columnKey,
    sort?.direction,
    userManagementStore.getGridFilters()
  ]
}

export const useGetUsersPaged = ({
  sort,
  enabled,
  filters
}: UseGetUsersProps) => {
  const { getUsersPaged } = useBSTInsightsAPI();
  const { getTokenSilently } = useAcquireToken();

  return useInfiniteQuery({
    queryKey: [
      GRID_DATA_QUERY_PREFIX,
      sort?.columnKey,
      sort?.direction,
      filters
    ],
    queryFn: async ({ pageParam }) => {
      const token = await getTokenSilently();

      if (!token) return [];

      return await getUsersPaged(
        token,
        {
          pageSize: PAGE_SIZE,
          pageNumber: pageParam,
          sortBy: sort?.columnKey,
          sortDirection: sort?.direction,
          filters
        }
      ) || [];
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage) => {
      const lastPageItem = lastPage?.[lastPage.length - 1];
      return lastPageItem?.rowNumber
        ? Number(lastPageItem.rowNumber)
        : undefined;
    },
    select: (data) => data.pages.flatMap((page) => page),
    enabled
  });
}
